import { Translations, translationsFromJson } from './common';
import { ISO_LanguageCode } from './localization.utils';

export type TranslationLanguage = ISO_LanguageCode;
export const TranslationLanguage = {
  [ISO_LanguageCode.EN]: ISO_LanguageCode.EN,
  [ISO_LanguageCode.LT]: ISO_LanguageCode.LT,
  [ISO_LanguageCode.IT]: ISO_LanguageCode.IT,
  [ISO_LanguageCode.JA]: ISO_LanguageCode.JA,
  [ISO_LanguageCode.NL]: ISO_LanguageCode.NL,
  [ISO_LanguageCode.DE]: ISO_LanguageCode.DE,
};

export class Translation {
  language: TranslationLanguage;
  translations: Translations;

  private constructor(language: TranslationLanguage, translations: Translations) {
    this.language = language;
    this.translations = translations;
  }

  static fromTranslations(language: TranslationLanguage, translations: Translations) {
    return new Translation(language, translations);
  }

  static fromJson(language: TranslationLanguage, json: string) {
    return new Translation(language, translationsFromJson(JSON.parse(json)));
  }
}
